// define the state model
export const Navigate = {
  // navigation destination
  destination: null,
};
